module.exports = __webpack_public_path__ + "img/deco_bird_blue.3e118df2.png";